import React from 'react';
import { getTranslation } from '../../../utils/translation';
import classNames from 'classnames';
import styles from './BookedBadge.module.scss';

const BookedBadge = ({ isBooked, isLive }) => {
    return !isLive ? (
        <span
            className={classNames(styles.badge, {
                visible: isBooked,
            })}
        >
            {getTranslation('common.live')}
        </span>
    ) : null;
};

export default BookedBadge;
